// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3otiU","resendInfoText":"OnGoingPaymentBox_resendInfoText__sARsW"};